import { useContext } from 'react';
import styled from 'styled-components';
import { ConstraintContainer } from 'src/components/common/ConstraintContainer';
import { media } from 'src/styles/designs';
import { Markdown } from 'vendor/mods/markdown/components/Markdown';
import { useTranslate } from 'react-t7e';
import { EventPageHeading } from 'src/modules/events/components/EventPage/EventPageHeading';
import { useFlattenEvent } from 'src/modules/events/hooks/useFlattenEvent';
import { EventPageContext } from 'src/modules/events/components/EventPage/EventPageContext';

const Section = styled.section`
  padding: 20px 0 34px;
  background: ${({ theme }) => theme.palette.white};
  ${media.w.greaterThanOrEqual.desktop} {
    padding: 54px 0 76px;
  }
`;

const Container = styled(ConstraintContainer)`
  max-width: 1020px;
  ${media.w.greaterThanOrEqual.desktop} {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }
`;

const Description = styled.div`
  font-size: 16px;
  line-height: 24px;
  font-weight: 300;
  width: 100%;
  max-width: 650px;
  color: ${({ theme }) => theme.text.palette.primary};
  ${media.w.lessThan.desktop} {
    font-size: 14px;
    line-height: 21px;
    padding-top: 16px;
  }
`;

const TagsWrapper = styled.div`
  margin-top: 24px;
  ${media.w.lessThan.desktop} {
    opacity: 0.6;
  }
`;

const TopicsHeading = styled.h3`
  font-weight: 300;
  font-size: 14px;
  line-height: 120%;
  text-transform: uppercase;
  margin-bottom: 4px;
  color: ${({ theme }) => theme.text.palette.accent};
`;

const Tags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 2px 10px;
`;

const Tag = styled.div`
  font-size: 16px;
  line-height: 24px;
  font-weight: 300;
`;

export const EventPageAboutSection = () => {
  const { _ } = useTranslate();

  const { event } = useContext(EventPageContext);

  const flatEvent = useFlattenEvent(event);

  return (
    <Section>
      <Container>
        <EventPageHeading>{_('ABOUT')}</EventPageHeading>
        <Description>
          <Markdown>{flatEvent.description}</Markdown>
          {flatEvent.tags.length > 0 && (
            <TagsWrapper>
              <TopicsHeading>{_('EVENT TOPICS')}</TopicsHeading>
              <Tags>
                {flatEvent.tags.map(({ name, id }) => (
                  <Tag key={id}>{name}</Tag>
                ))}
              </Tags>
            </TagsWrapper>
          )}
        </Description>
      </Container>
    </Section>
  );
};
